/* eslint-disable no-unused-vars */
import HttpBase from "./http.base";
import AppConstants from "../constants.js";

import { IUserDetails } from "interfaces";

class HttpIAM extends HttpBase {
  login = (UserName: string, Password: string): Promise<any> => {
    return this.POST(`${AppConstants.baseURL}/api/authentication/login`, {
      UserName,
      Password,
    });
  };

  /**
   * Exchange OTP + CorrelationId for JWT token (SSO)
   */
  exchangeOtp = (otp: string): Promise<any> => {
    return this.POST(
      `${AppConstants.baseURL}/api/authentication/exchange-otp`,
      {
        otp,
      }
    );
  };

  getUserDetails = (userName: string): Promise<IUserDetails> => {
    return this.GET(
      `${AppConstants.baseURL}/api/userdetail/get-user-details/${userName}`
    );
  };
}

const httpIAM = new HttpIAM();
export { httpIAM };
